import React from 'react';

const CgvPage = () => {
  return (
    <div className="min-h-screen bg-[#FDFAF4] py-16 px-6" data-testid="cgv-page">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs uppercase tracking-[0.3em] text-[#B8922A] mb-3">Espace légal</p>
          <h1
            className="text-4xl md:text-5xl font-light mb-3 text-[#5C2018]"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
          >
            Conditions Générales de Vente
          </h1>
          <p className="text-xs text-[#332724]/60 italic">Dernière mise à jour : février 2026</p>
        </div>

        <div className="space-y-8 text-[#332724] font-light leading-relaxed">

          <section>
            <h2 className="text-2xl mb-3 text-[#5C2018]" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              1. Identification du vendeur
            </h2>
            <p className="text-sm">
              <strong>Maison Harmony Parfumerie</strong> — Bar à parfums, boutique située au Polygone de Béziers,
              14 Avenue Sergent Bobillot, 34500 Béziers, France.<br />
              Email : contact@maison-harmony.fr · Téléphone : 04 67 21 57 08<br />
              <em>Toutes les informations légales détaillées (SIRET, TVA, directeur de publication) sont disponibles sur la page Mentions légales.</em>
            </p>
          </section>

          <section>
            <h2 className="text-2xl mb-3 text-[#5C2018]" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              2. Objet & champ d'application
            </h2>
            <p className="text-sm">
              Les présentes CGV régissent toute vente conclue à distance via le site harmony-parfumerie.fr.
              Toute commande implique l'acceptation pleine et entière des présentes conditions, qui prévalent
              sur tout autre document. Les CGV peuvent être modifiées à tout moment ; la version applicable est
              celle en vigueur au jour de la commande.
            </p>
          </section>

          <section>
            <h2 className="text-2xl mb-3 text-[#5C2018]" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              3. Produits & services
            </h2>
            <p className="text-sm mb-2">
              Harmony commercialise des flacons de parfum (Rituels Découverte et Signature), recharges
              éco-responsables, échantillons 2 ml, bons cadeaux, abonnements mensuels Flacon Nomade et
              vaporisateurs de sac. Chaque achat de flacon inclut une consultation olfactive 15 min offerte,
              utilisable sur rendez-vous ou non, à la discrétion du client.
            </p>
            <p className="text-sm">
              <strong>Photos non contractuelles :</strong> les visuels du site sont indicatifs. La présentation
              effective des produits (flacons, coffrets, accessoires, coloris des vaporisateurs) peut varier
              selon les arrivages.
            </p>
          </section>

          <section>
            <h2 className="text-2xl mb-3 text-[#5C2018]" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              4. Prix
            </h2>
            <p className="text-sm">
              Les prix sont indiqués en euros, toutes taxes comprises (TTC), hors frais de livraison. Les frais
              de port sont précisés avant validation de la commande. Les prix peuvent être modifiés à tout moment ;
              les produits commandés sont facturés au tarif en vigueur lors de la validation de la commande.
            </p>
          </section>

          <section>
            <h2 className="text-2xl mb-3 text-[#5C2018]" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              5. Paiement
            </h2>
            <p className="text-sm">
              Le paiement s'effectue en ligne par carte bancaire (via la plateforme sécurisée Square) ou via
              PayPal. Aucune donnée bancaire n'est conservée par Harmony. La commande est définitive après
              encaissement effectif. En cas de refus de paiement, la commande est automatiquement annulée.
            </p>
          </section>

          <section>
            <h2 className="text-2xl mb-3 text-[#5C2018]" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              6. Retrait en boutique (Click &amp; Collect) ou livraison
            </h2>
            <p className="text-sm mb-2">
              Lors du passage de commande, le client choisit son mode de récupération :
            </p>
            <ul className="text-sm list-disc list-inside space-y-2">
              <li>
                <strong>Retrait en boutique (Click &amp; Collect) — gratuit.</strong> Le client s'engage à venir
                récupérer sa commande au point de vente Harmony Parfumerie (14 Avenue Sergent Bobillot, 34500 Béziers)
                aux horaires d'ouverture.
                <strong> Aucune expédition n'est effectuée pour les commandes en Click &amp; Collect</strong> :
                il appartient exclusivement au client de se déplacer en boutique pour retirer sa commande.
                <strong> Aucun remboursement ne sera effectué en cas de non-retrait</strong> : il appartient à
                la personne qui a passé commande de venir retirer son achat.
              </li>
              <li>
                <strong>Livraison France métropolitaine — 8,90€ Colissimo</strong>, offerte dès 60€ d'achat.
                Cette option doit être <strong>explicitement choisie et cochée par le client au moment du paiement</strong>.
                Seules les commandes pour lesquelles l'option « Livraison » a été sélectionnée donnent lieu à une
                expédition à l'adresse renseignée. Délai indicatif : 3 à 5 jours ouvrés à compter de l'expédition.
                <strong> Harmony Parfumerie ne peut être tenue responsable du transport effectué par La Poste / Colissimo</strong> :
                pertes, retards, dommages ou erreurs d'acheminement relèvent exclusivement de la responsabilité du transporteur.
              </li>
            </ul>
            <p className="text-sm mt-2">
              Les commandes en Click &amp; Collect non retirées au-delà de <strong>30 jours</strong> sans
              manifestation du client pourront être remises en stock sans remboursement automatique. En cas
              d'absence prolongée, contactez-nous au 04 67 21 57 08.
            </p>
          </section>

          <section>
            <h2 className="text-2xl mb-3 text-[#5C2018]" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              7. Droit de rétractation (14 jours)
            </h2>
            <p className="text-sm mb-2">
              Conformément à l'<strong>article L221-18 du Code de la consommation</strong>, le client dispose
              d'un délai de <strong>14 jours calendaires</strong> à compter de la réception du produit (ou
              du retrait en boutique pour le Click &amp; Collect) pour exercer son droit de rétractation,
              sans avoir à justifier de motif ni à payer de pénalité.
            </p>
            <p className="text-sm mb-2">
              <strong>Modalités :</strong> envoyer un email à contact@maison-harmony.fr (ou notification écrite en
              boutique) indiquant la commande concernée. Les produits doivent être retournés <strong>neufs, non
              ouverts, non utilisés, dans leur emballage d'origine</strong>, sous 14 jours suivant la rétractation.
              Les frais de retour sont à la charge du client. Le remboursement (hors frais de port aller) intervient
              dans les 14 jours suivant la réception du retour.
            </p>
            <p className="text-sm mb-2">
              <strong>Exclusions du droit de rétractation</strong> (article L221-28 du Code de la consommation) :
            </p>
            <ul className="text-sm list-disc list-inside space-y-1">
              <li>
                <strong>Produits personnalisés</strong> : tout flacon ayant fait l'objet d'une <em>Personnalisation +5€</em>
                (formule unique enregistrée au fichier client) est confectionné sur-mesure et n'est <strong>pas
                éligible au droit de rétractation</strong>.
              </li>
              <li>
                <strong>Échantillons 2 ml usagés</strong> : les échantillons ouverts ou utilisés ne peuvent être
                retournés pour des raisons d'hygiène et de protection de la santé (article L221-28 5°). Les
                échantillons scellés et non-ouverts restent rétractables.
              </li>
              <li>
                <strong>Recharges entamées</strong> : pour des raisons d'hygiène, les recharges ouvertes ne peuvent
                être retournées.
              </li>
              <li>
                <strong>Bons cadeaux</strong> : les bons cadeaux délivrés numériquement et utilisés (en tout ou
                partie) ne sont pas rétractables. Bons non utilisés : rétractables dans les 14 jours.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl mb-3 text-[#5C2018]" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              8. Garanties légales
            </h2>
            <p className="text-sm">
              Les produits Harmony bénéficient automatiquement de la <strong>garantie légale de conformité</strong>
              (articles L217-3 et suivants du Code de la consommation) et de la <strong>garantie contre les vices
              cachés</strong> (articles 1641 et suivants du Code civil). En cas de défaut, le client peut obtenir
              la réparation, le remplacement ou le remboursement du produit.
            </p>
          </section>

          <section>
            <h2 className="text-2xl mb-3 text-[#5C2018]" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              9. Programme de fidélité « Cercle Harmony »
            </h2>
            <p className="text-sm mb-3">
              Le programme de fidélité <strong>Cercle Harmony</strong> est gratuit, sans engagement et réservé
              aux personnes physiques majeures résidant en France métropolitaine.
            </p>
            <ul className="text-sm list-disc list-inside space-y-2 mb-3">
              <li>
                <strong>Points :</strong> 1€ TTC dépensé chez Maison Harmony = 1 point.
                Conversion : 100 pts = 10€ offerts · 250 pts = 30€ offerts · 500 pts = 75€ offerts.
                Points crédités sous 48h après l&apos;achat confirmé.
              </li>
              <li>
                <strong>Cadeau anniversaire :</strong> -20% sur tout achat pendant le mois calendaire d&apos;anniversaire,
                sur présentation du code envoyé par email le 1ᵉʳ du mois.
              </li>
              <li>
                Les points n&apos;expirent pas. Le programme n&apos;est pas cumulable avec d&apos;autres
                réductions promotionnelles ponctuelles, et est non applicable aux bons cadeaux,
                échantillons et frais de port.
              </li>
              <li>
                Les avantages fidélité ne sont ni cessibles, ni remboursables, ni échangeables contre des espèces.
              </li>
              <li>
                Maison Harmony se réserve le droit de modifier ou suspendre le programme à tout moment,
                avec préavis raisonnable communiqué par email aux membres.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl mb-3 text-[#5C2018]" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              10. Médiation de la consommation
            </h2>
            <p className="text-sm">
              Conformément à l'article L612-1 du Code de la consommation, en cas de litige non résolu à l'amiable,
              le consommateur peut recourir gratuitement à un médiateur de la consommation. Le médiateur
              compétent est : <strong>CNPM – Médiation de la consommation</strong>, 27 avenue de la Libération,
              42400 Saint-Chamond — <a href="https://www.cnpm-mediation-consommation.eu" target="_blank" rel="noopener noreferrer" className="text-[#1E7A6A] underline">cnpm-mediation-consommation.eu</a>.
              Plateforme européenne de règlement des litiges en ligne :{' '}
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[#1E7A6A] underline">ec.europa.eu/consumers/odr</a>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl mb-3 text-[#5C2018]" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              11. Données personnelles (RGPD)
            </h2>
            <p className="text-sm">
              Les données collectées lors d'une commande (nom, email, adresse) sont utilisées exclusivement pour
              le traitement de la commande et, sur consentement, pour vous tenir informé(e) de nos actualités.
              Pour plus de détails sur le traitement de vos données, consultez notre <a href="/confidentialite" className="text-[#1E7A6A] underline">Politique de confidentialité</a>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl mb-3 text-[#5C2018]" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              12. Propriété intellectuelle
            </h2>
            <p className="text-sm">
              L'ensemble des éléments du site (textes, images, logo H, marque Maison Harmony, photos de la
              boutique et des produits) sont protégés par le droit d'auteur et le droit des marques. Toute
              reproduction sans autorisation préalable et écrite est strictement interdite.
            </p>
          </section>

          <section>
            <h2 className="text-2xl mb-3 text-[#5C2018]" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              13. Droit applicable & juridiction
            </h2>
            <p className="text-sm">
              Les présentes CGV sont soumises au droit français. En cas de litige et à défaut de résolution
              amiable, les tribunaux français seront seuls compétents.
            </p>
          </section>

          <p className="text-xs text-center text-[#332724]/60 italic pt-8">
            Maison Harmony Parfumerie · 14 Avenue Sergent Bobillot, 34500 Béziers · contact@maison-harmony.fr
          </p>
        </div>
      </div>
    </div>
  );
};

export default CgvPage;
